"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// From this quip https://gist.github.com/kaizhu256/4482069
var getGuid = function getGuid() {
  // return uuid of form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
  var uuid = '';
  var currentChar;

  for (currentChar = 0; currentChar <
  /* 36 minus four hyphens */
  32; currentChar += 1) {
    switch (currentChar) {
      case 8:
      case 20:
        uuid += '-';
        uuid += (Math.random() * 16 | 0).toString(16);
        break;

      case 12:
        uuid += '-';
        uuid += '4';
        break;

      case 16:
        uuid += '-';
        uuid += (Math.random() * 4 | 8).toString(16); // Not the difference for this position

        break;

      default:
        uuid += (Math.random() * 16 | 0).toString(16);
    }
  }

  return uuid;
};

var _default = getGuid;
exports["default"] = _default;